exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.status-consulting {\n  font-size: 15px;\n  color: #6c757d;\n  font-weight: bold;\n  border-bottom: 0;\n}\n\n.button-clean {\n  background: #fffa;\n}\n\na.download-xlsx {\n  text-decoration: none\n}\n\ni.icon-check {\n  color: #00ab98\n}\n\ni.icon-minus {\n  color: #e90022\n}", ""]);

// exports
